import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { minicrudsClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import useRouteParams from '../../../../utils/routes/helpers/useParam'

const Context = React.createContext()
const { Provider } = Context
export const useMinicrudsState = () => React.useContext(Context) || {}
export const useMinicruds = () => useMinicrudsState()?.minicruds || []

const QUERY = gql`
  query Minicruds($page: Int, $search: String, $sort: [MinicrudSort], $filter: MinicrudFilter) {
    minicruds(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      entity
    }
  }
`

const MinicrudsLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()
  const entity = useRouteParams('entity')

  const { data, fetchMore, variables, done, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'NAME', type },
      filter: { ...filter, entities: entity }
    },
    client: minicrudsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
      </StatePresenter>
      <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} disabled={done} />
    </Provider>
  )
}

export default MinicrudsLoader
